module.exports = __webpack_public_path__ + "static/pexa-78b6934c867beaac296db95c2817d6ae.svg";